export default __webpack_public_path__ + "static/media/filter_icon_garden.486046e4.svg";